import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../contentConstants';

export const NoValueWrapper = styled.span`
	font-style: italic;
`;
NoValueWrapper.displayName = 'NoValue';

export const NoValue = <NoValueWrapper>{ContentConstants.NO_VALUE}</NoValueWrapper>;
